import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/HomePage/Home';
import ReservationPage from './pages/ReservationPage/ReservationPage';
import NonExistPage from './pages/NonExistPage/NonExistPage';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import PaymentReturn from './pages/PaymentReturn/PaymentReturn';
import PaymentNotification from './pages/PaymentNotification/PaymentNotification';

const queryClient = new QueryClient();

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/reservationPage" element={<ReservationPage />} />
          <Route path="*" element={<NonExistPage />} />
          <Route path='/payment/return' element={<PaymentReturn />} />
          <Route path='/payment/notify' element={<PaymentNotification />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
